var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNouncall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8367 6.171C23.0423 7.44264 23.9521 8.62834 24.1504 9.79081C24.1176 12.4133 21.6446 15.6609 18.6728 18.6282C15.7167 21.5799 12.2932 24.494 9.80377 24.1165C8.634 23.9176 7.44063 23.0007 6.15822 21.7862C5.74633 21.3935 5.74657 20.5481 6.16629 20.129L8.69726 17.6019C9.13387 17.1659 9.98044 17.1657 10.5365 17.4601L12.2405 18.7074C13.1498 19.4821 15.0655 17.5814 16.3372 16.3115C17.606 15.0446 19.5421 13.3245 18.7259 12.213L17.4803 10.5165C17.1899 9.96708 17.1899 9.12186 17.6063 8.70609L20.1274 6.1888C20.5772 5.73967 21.4239 5.73933 21.8367 6.171Z",
    fill: "#4DA528"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 29.1,
    fill: "white",
    transform: "matrix(-1 0 0 1 30 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNouncall);
export default __webpack_public_path__ + "static/media/nouncall.79b09d44c259c70b878eeb7867d23ba8.svg";
export { ForwardRef as ReactComponent };